





























































import {
  Component, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Table from '@/components/Table/Index.vue';
import ActivityBody from '@/components/Table/ActiveBody.vue';
import ActivityData from '@/data/ActivityData';
import { IfetchActivity, IActivityLog } from '@/interface/Activity';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ActivityModule from '@/store/modules/Activity';
import Pagination from '@/components/Pagination.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    ActivityBody,
    Table,
    Pagination,
  },
})
export default class ActivityLogLogin extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  TableHeadActivity = ActivityData.TableHead;

  ActivityInstance = getModule(ActivityModule, this.$store);

  activityTypeList = [
    'ALL',
    'LOGIN',
    'REFRESH TOKEN',
  ];

  userData: Array<IActivityLog> = [
    {
      device: '',
      ipAddress: '',
      timestamp: '',
      role: '',
      username: '',
      type: '',
    },
  ]

  search: IfetchActivity = {
    username: '',
    type: 'ALL',
  };

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  };

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchActivityLog();
  }

  async fetchActivityLog() {
    this.GeneralInstance.toggleLoading(true);
    const params = {
      username: this.search.username,
      type: this.search.type === 'REFRESH TOKEN' ? 'REFRESH_TOKEN' : this.search.type,
      ...this.PaginationDetail,
    };
    const { data, status } = await this.ActivityInstance.FetchActivityLog(params);
    this.checkError(status);
    if (status.code === 0 && data.resLog) {
      this.PaginationDetail.amount = data.pageAmount;
      this.userData = data.resLog.sort((a: any, b: any) => b.timestamp - a.timestamp);
    } else if (status.code === 0 && !data.resLog) {
      this.userData = data;
    }
    this.GeneralInstance.toggleLoading(false);
  }
}
